import prefilled from "./prefilled";
import { storage, STORAGE_KEYS } from "./Storage";

const buildHeaders = (token: string | null): HeadersInit => {
  const headers: Record<string, string> = { "Content-Type": "application/json" };
  if (token && token !== "null") {
    headers["Authorization"] = `Bearer ${token}`;
  }
  return headers;
};

const fetchToken = async (url: string, token: string | null): Promise<string> => {
  const response = await fetch(url, {
    method: "Post",
    mode: "cors",
    headers: buildHeaders(token),
  });
  const data = await response.json();
  return data.token as string;
};

export const tokenProcess = async () => {
  const greeting = {
    auth: "",
    agent: navigator.userAgent || "unknown-agent",
  };

  const url = `${prefilled.socketUrl}/excel/token`;
  //const documentId = Office.context.document.settings.get('documentId');
  const storedToken = storage.getItem(STORAGE_KEYS.PW_TOKEN);

  let newToken: string;
  try {
    newToken = await fetchToken(url, storedToken);
  } catch {
    storage.removeItem(STORAGE_KEYS.PW_TOKEN);
    newToken = await fetchToken(url, null);
  }

  storage.setItem(STORAGE_KEYS.PW_TOKEN, newToken);
  greeting.auth = newToken;
  return greeting;
};
